// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__36E7t","clinicsSelect":"TableHeading_clinicsSelect__3xu-B"};